import { GenericViewHeader } from 'back-office/shared/components/GenericViewHeader';
import { SimpleDashboardContent } from 'features/dashboard/DashboardContent';
import { TrendingUp } from 'lucide-react';
import { Outlet } from 'react-router-dom';

/** Écran « Catalogue › Indices ». */
export default function IndicesView() {
  return (
    <SimpleDashboardContent>
      <GenericViewHeader title="Indices" icon={TrendingUp} />
      <Outlet />
    </SimpleDashboardContent>
  );
}
